import React, { useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';

import PrivateHeader from 'containers/parts/PrivateHeader';
import { mappedProps } from 'containers/student/EntrustStudyUnit';
import SiteMain from 'containers/parts/SiteMain';
import { curriculums, disabledEntrustStudyTopicNames } from "../../utils/constants"
import { EntrustCurrentRecord } from '../../models/api';
import CorrectAnswerCount from './common/CorrectAnswerCount';

const EntrustStudyUnit: React.FC<mappedProps> = (props: mappedProps) => {
  const { unit_id } = useParams<{ unit_id: string }>();
  const history = useHistory()

  useEffect(() => {
    if (unit_id) {
      props.fetchData(Number(unit_id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unit_id]);

  useEffect(() => {
    props.fetchStudyAchievementsLatest();
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  , []);

  const page = props.student.studyUnit.record;
  const [curriculumCode, setCurriculumCodes] = useState<string>("")

  useEffect(() => {
    if (page) {
      const curriculum_code = curriculums.filter(x => {
        return x.id === page.curriculum.id
      })
      setCurriculumCodes(curriculum_code[0].code)
    }
  }, [page, props])

  const [topicId, setTopicId] = useState<number>(0);
  const [submitActive, setSubmitActive] = useState<boolean>(false);

  useEffect(() => {
    if (page) {
      props.fetchEntrustStudyData(page.curriculum.id).catch(error => {
        // MARK: 取得リクエストでエラーになった場合にTOPにリダイレクトする
        history.push('/')
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const [entrustStudyRecords, setEntrustStudyRecords] = useState<EntrustCurrentRecord[] | null>(null);
  useEffect(() => {
    const records = props.getEntrustStudyState();
    if (records) {
      setEntrustStudyRecords(records)
    }
    //  eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.fetchEntrustStudyData]);
  
  const submit = () => {
    if (page) {
      props.updateEntrustBaseTopic(topicId).then(
        () => {
          history.push(`/entrust/${curriculumCode}`)
        })
    }
  }

  const checkBoxHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSubmitActive(true);
  }

  return (
    <React.Fragment>
      <PrivateHeader />
      <SiteMain>
        <ol className="breadcrumbs">
          <li className="breadcrumbs__item">
            <Link to='/' className="breadcrumbs__link">マイページ</Link>
          </li>
          {
            page &&
            <React.Fragment>
              <li className="breadcrumbs__item">
                <Link to={`/entrust_setting/${page.curriculum.id}`} className="breadcrumbs__link">
                  おまかせ学習{"(" + page.curriculum.name + ")"}
                </Link>
              </li>
              <li className="breadcrumbs__item">
                <Link to={`/entrust_setting/courses/${page.course.id}`} className="breadcrumbs__link">
                  {page.course.name}
                </Link>
              </li>
              <li className="breadcrumbs__item">
                {page.unit.name}
              </li>
            </React.Fragment>
          }
        </ol>

        {
          page &&

          <div className="site-main__main-contents">
            <div className="page-title">
              <div className="page-title__left">
                おまかせ学習設定{"（" + page.curriculum.name + "）"}
                &nbsp;
                <div className="page-title__badge">
                 {page.course.name}
                </div>
                &nbsp;
                <br className="_sp" />{page.unit.name}
              </div>
              <div className="page-title__correct-count">
                {props.student.studyAchievementsLatest.record && <>
                <CorrectAnswerCount correctAnswerCount={props.student.studyAchievementsLatest.record.study_achievements.consecutive_correct_answer_count}/>
              </>}
            </div>  
            </div>

            {
              page.curriculum.al_engine_connected &&
              <div className="suggestion-box">
                AIがおすすめするカリキュラムを進めていくとテストの受講が可能です。
                「<Link to={`/recommends/${page.curriculum.id}`} className="">もっともおすすめ学習</Link>」からご確認ください。
              </div>
            }

            {
              // MARK: 教科：英語 単元：関係詞
              page.curriculum.id === 2 && page.unit.id === 31 &&
              <div className="entrust-topic-additional-info">
                <p>
                  6-16：That is why …「そういうわけで…」/That is because …「それは…だからだ」は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }
            {
                // MARK: 教科：英語 単元：接続詞
              page.curriculum.id === 2 && page.unit.id === 32 &&
              <div className="entrust-topic-additional-info">
                <p>
                7-29：接続詞as(全体像) は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：英語 単元：比較
              page.curriculum.id === 2 && page.unit.id === 33 &&
              <div className="entrust-topic-additional-info">
                <p>
                  8-1：比較級の作り方、8-2：比較級変化が2つあるもの、8-27：最上級の作り方、8-28：最上級変化が3つあるものは「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：英語 単元：代名詞
              page.curriculum.id === 2 && page.unit.id === 34 &&
              <div className="entrust-topic-additional-info">
                <p>
                  9-15：someとanyの用法＜anyの用法：肯定文の場合＞、9-16：someとanyの用法＜anyの用法：否定文の場合＞、9-17：someとanyの用法＜anyの用法：疑問文の場合＞、9-29：人称代名詞の格変化は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：化学 単元：物質の構成
              page.curriculum.id === 4 && page.unit.id === 51 &&
              <div className="entrust-topic-additional-info">
                <p>
                  1-7：元素の性質と周期表、1-13：分子とその形は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：化学 単元：物質の変化
              page.curriculum.id === 4 && page.unit.id === 52 &&
              <div className="entrust-topic-additional-info">
                <p>
                  2-8：酸と塩基の性質、2-11：水の電離、2-23：電池は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：化学 単元：化学反応と電気エネルギー
              page.curriculum.id === 4 && page.unit.id === 53 &&
              <div className="entrust-topic-additional-info">
                <p>
                  3-2：ファラデー定数は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：化学 単元：物質の状態と化学平衡
              page.curriculum.id === 4 && page.unit.id === 54 &&
              <div className="entrust-topic-additional-info">
                <p>
                  4-3：体積と圧力、4-4：体積と温度、4-9：分子間力、4-16：溶解、4-19：希薄溶液の性質は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：化学 単元：物質の変化と平衡
              page.curriculum.id === 4 && page.unit.id === 55 &&
              <div className="entrust-topic-additional-info">
                <p>
                  5-9：活性化エネルギー、5-13：濃度・温度と反応速度、5-14：可逆変化と化学平衡、5-17：水の電離平衡、5-18：水素イオン濃度とpH、5-21：緩衝液は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：化学 単元：有機化合物
              page.curriculum.id === 4 && page.unit.id === 57 &&
              <div className="entrust-topic-additional-info">
                <p>
                  7-1：有機化合物の特徴は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：化学 単元：高分子化合物
              page.curriculum.id === 4 && page.unit.id === 58 &&
              <div className="entrust-topic-additional-info">
                <p>
                  8-7：等電点と電気泳動、8-12：DNAの二重らせん構造、8-13：DNAの複製とはたらき、8-14：高分子の基礎、8-19：付加縮合で合成される高分子（熱硬化性樹脂）は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：古文 単元：導入
              page.curriculum.id === 5 && page.unit.id === 59 &&
              <div className="entrust-topic-additional-info">
                <p>
                  1-1：古典文法とは、1-8：活用とはは「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：古文 単元：用言
              page.curriculum.id === 5 && page.unit.id === 60 &&
              <div className="entrust-topic-additional-info">
                <p>
                  2-1：動詞とは、2-13：自動詞と他動詞、2-15：形容詞とは、2-18：形容動詞とは、2-21：用言の音便とはは「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：古文 単元：助動詞
              page.curriculum.id === 5 && page.unit.id === 61 &&
              <div className="entrust-topic-additional-info">
                <p>
                  3-1：助動詞とは、3-2：助動詞の働きと分類は「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：古文 単元：助詞
              page.curriculum.id === 5 && page.unit.id === 62 &&
              <div className="entrust-topic-additional-info">
                <p>
                  4-1：助詞の種類と働き、4-2：格助詞とは、4-12：接続助詞とは、4-23：係助詞とは、4-31：副助詞とは、4-40：終助詞とは、4-52：間投助詞とはは「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：古文 単元：敬語
              page.curriculum.id === 5 && page.unit.id === 63 &&
              <div className="entrust-topic-additional-info">
                <p>
                  5-1：敬語とはは「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：古文 単元：識別
              page.curriculum.id === 5 && page.unit.id === 64 &&
              <div className="entrust-topic-additional-info">
                <p>
                  6-1：識別とはは「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            {
              // MARK: 教科：古文 単元：和歌修辞
              page.curriculum.id === 5 && page.unit.id === 65 &&
              <div className="entrust-topic-additional-info">
                <p>
                  7-2：倒置・体言止めは「学習設定」ではチェックを入れずに、「教科単元選択学習」から学習してください。
                </p>
              </div>
            }

            <div className="topic-list">
              <div className="topic-list__head entrust-topic-list_head">
                <div className="topic-list__title entrust-topic-list__title">
                  “{page.unit.name}”のトピック
                </div>
                <div className="entrust-head-note">
                  おまかせ設定
                </div>
              </div>
              <div className="topic-list__body">

                {page &&
                  page.topics.map((topic: any, index) => (
                    <div key={index} className="topic-list__item entrust-topic-list__item">
                      <div className="entrust-topic-list__body-inner">
                        <input className="entrust-input-check-box" checked={topic.id === topicId} type="checkbox" id={`topic-${topic.id}`} name={`topic-${topic.id}`} disabled={disabledEntrustStudyTopicNames.includes(topic.title)}
                          onChange={(e) => {
                            setTopicId(topic.id)
                            checkBoxHandler(e)
                          }}
                        />
                        <label className="entrust-input-label" htmlFor={`topic-${topic.id}`} >
                          {topic.title}
                        </label>
                      </div>
                      {entrustStudyRecords && entrustStudyRecords.length > 0 && entrustStudyRecords[0].topic.description && topic.title === entrustStudyRecords[0].topic.description && <>
                        <p className="entrust-selected">設定済</p>
                      </>}
                    </div>
                  ))
                }
              </div>
            </div>
            <div className="entrust-unit-center">

              <Link to={`/entrust/${curriculumCode}`} className=" button button--outline-cancel  entrust-button">反映せずに戻る</Link>
              <button
                className="button button--primary entrust-button"
                onClick={x => {
                  submit()
                }}
                disabled={!submitActive}
              >
                設定する
              </button>
            </div>
          </div>
        }

        <ol className="breadcrumbs">
          <li className="breadcrumbs__item">
            <Link to='/' className="breadcrumbs__link">マイページ</Link>
          </li>
          {
            page &&
            <React.Fragment>
              <li className="breadcrumbs__item">
                <Link to={`/entrust_setting/${page.curriculum.id}`} className="breadcrumbs__link">
                  おまかせ学習{"(" + page.curriculum.name + ")"}
                </Link>
              </li>
              <li className="breadcrumbs__item">
                <Link to={`/entrust_setting/courses/${page.course.id}`} className="breadcrumbs__link">
                  {page.course.name}
                </Link>
              </li>
              <li className="breadcrumbs__item">
                {page.unit.name}
              </li>
            </React.Fragment>
          }
        </ol>

      </SiteMain>
    </React.Fragment>
  );
}

export default EntrustStudyUnit